var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickupPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 8.33342C16.6667 13.682 10 18.3334 10 18.3334C10 18.3334 3.33337 13.682 3.33337 8.33342C3.33337 4.65152 6.31814 1.66675 10 1.66675C13.6819 1.66675 16.6667 4.65152 16.6667 8.33342Z",
    fill: "#AA8768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupPoint);
export default __webpack_public_path__ + "static/media/PickupPoint.46765828145f8d02c8c10e7b6cd40651.svg";
export { ForwardRef as ReactComponent };